import React, { useState, useEffect, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import { observer } from 'mobx-react';
import { useStore } from '../../sdo.js'
import {useNavigate} from "react-router-dom";
import sso from "../../sso";

function Fakt_Mnu(props) {
    var navigate = useNavigate();
    let [state, setState] = useState({mnu: "", row: {}, htitle: "", ma: []});
    let ctx = useStore();

    var lock = "lock";
    var moa = {};
    moa["f00"] = { fid: "f00", name: "Hem", url: "/fakt", icon: "home", fa: "fa fa-home flex", ma: [] };
    moa["f01"] = { fid: "f01", name: "Kunder", url: "/fakt/kreg", icon: "key", fa: "fa fa-key flex", ma: [] };
    moa["f02"] = { fid: "f02", name: "Frontoffice", url: "/fakt/fo", icon: "play", fa: "fa fa-play flex", ma: [] };
    moa["f03"] = { fid: "f03", name: "Reskontra", url: "/fakt/rsk", icon: "chart-bar", fa: "fa fa-chart-bar flex", ma: [] };
    moa["f04"] = { fid: "f04", name: "Ekonomi", url: "/fakt/und", icon: "list-alt", fa: "fa fa-list-alt flex", ma: [] };
    moa["f05"] = { fid: "f05", name: "Backoffice", url: "/fakt/bo", icon: "cogs", fa: "fa fa-cogs flex", ma: [] };

    moa["f01"].ma.push( { fid: "f01", name: "Kunder", url: "/fakt/kreg/kund", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "f01", name: "Statistik", url: "/fakt/kreg/stat", fa: "fa fa-bars" } );

    moa["f02"].ma.push( { fid: "f02", name: "Underlag / Notor", url: "/fakt/fo/und", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Kund Underlag", url: "/fakt/fo/kund", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Intern Reskontra", url: "/fakt/fo/intrsk", fa: "fa fa-bars" } );

    moa["f03"].ma.push( { fid: "f03", name: "Reskontra", url: "/fakt/rsk/rsk", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Påminnelser", url: "/fakt/rsk/rmd", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Räntehantering", url: "/fakt/rsk/int", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Historik", url: "/fakt/rsk/hist", fa: "fa fa-bars" } );

    moa["f04"].ma.push( { fid: "f04", name: "Rapporter", url: "/fakt/und/rps", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Listor", url: "/fakt/und/list", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Register", url: "/fakt/und/reg", fa: "fa fa-bars" } );

    moa["f05"].ma.push( { fid: "f05", name: "Företag", url: "/fakt/bo/ftg", fa: "fa fa-bars" } );
    moa["f05"].ma.push( { fid: "f05", name: "Parametrar", url: "/fakt/bo/prm", fa: "fa fa-bars" } );
    moa["f05"].ma.push( { fid: "f05", name: "Artiklar", url: "/fakt/bo/art", fa: "fa fa-bars" } );

    var aa = [];
    var keys = Object.keys(moa);
    for(var key of keys) {
        var o = moa[key];
        aa.push( o );
    }

    var ma = [];
    var mnuHeight = window.innerHeight - 100;

   function fknGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    var fkn = row.fid;
    setState({ mnu : row.fid, row : row,  ma : [] });
    ctx.fid = fkn;

       sso.seo.sfkn = row;
    //props.store.fkn = row;
       navigate(row.url);
   };
   function fknFix(fkn) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    ctx.fid = fkn;

    if(fkn == "lock") navigate('/web');
    if(fkn == "logout") navigate('/');
   };
   function mnuGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    //ctx.fid = fkn;
    setState({ mnu : state.hfid, row : state.row,  ma : [] });

       sso.seo.sfkn = row;
    //props.store.fkn = row;
       navigate(row.url);
   };
   function hideMnu() {
    setState({mnu : state.mnu, row : state.row, ma : [] });
   };
   function mouseEnter(it) {
    setState({mnu : state.mnu, row : state.row, hfid : it.fid, htitle : it.name, ma : it.ma });
   };
   function mouseLeave() {
    setState({mnu : state.mnu, row : state.row, ma : [] });
   };

   function row_css(row) {
  	    var css = {};
        css.margin = "0px";
        css.padding = "0px";
        css.height = "55px";
        css.borderBottom = "1px #ccc solid";

		if(state.mnu == row.fid) {
			css.background = "#080";
			css.color = "#fff";
		}
		return css;
    }
   function row_icon_css(row) {
  	    var css = {};
        css.paddingTop = "10px";
        css.fontSize = "20px";

		if(state.mnu == row.fid) {
			//css.color = "#ff9900";
			css.color = "#fff";
		}
		return css;
    }

   //<Icon className={ it.fa } style={{ fontSize: 18 }} />
   var html =
        <div className="">
        <div className="cdi_xmnu flex-fullcol" style={{padding: "5px 0px"}}>
            { aa.map((it, key) =>
            <div key={ key } onClick={() => fknGo(it)} className="web-col flex-cc xmnu_tab" style={ row_css(it) } onMouseEnter={ () => mouseEnter(it) }>
                <FontAwesomeIcon icon={ it.icon } size="1x" className="" style={ row_icon_css(it) } />
                <div style={{fontSize: "10px"}}>{ it.name }</div>
            </div>
            )}
            <div onClick={ () => fknFix("lock") } className="web-col flex-cc xmnu_tab">
                <FontAwesomeIcon icon="lock" size="1x" className="" style={{paddingTop: "10px", fontSize: "20px"}} />
                <div style={{fontSize: "10px"}}>Lås</div>
            </div>
            <div onClick={() => fknFix("logout") } className="web-col flex-cc xmnu_tab" >
                <i className="fa fa-power-off flex" aria-hidden="true" style={{paddingTop: "10px", fontSize: "20px"}}></i>
                <div style={{fontSize: "10px"}}>Logga ur</div>
            </div>
        </div>

            { state.ma.length ?
        <div className="mtrl_mnu_sub mtrl_mnu_bg" aria-label="Sub Menu" style={{height: mnuHeight}} onMouseLeave={mouseLeave}>
          <div className="mtrl_mnu_title" onClick={() => hideMnu()}>
            { state.htitle }
          </div>
            { state.ma.map((mi, key) =>
          <div key={key} className="mtrl_mnu_item flex-row" onClick={ () => mnuGo(mi) }>
            <div className="flex">{ mi.name }</div>
            <i className={ mi.fa } aria-hidden="true" style={ row_icon_css(mi) }></i>
          </div>
            )}
        </div>
                : null }
        </div>
    ;
    return html;
}

export default observer(Fakt_Mnu);
